import React, { useState, useEffect, useRef } from "react";
import MasterLayout from "../Sections/MasterLayout";
import Loader from "./Loader";
import {
  MapPin,
  Train,
  Users,
  TrendingUp,
  Download,
  Plus,
  Upload,
  RefreshCw,
  Zap,
  AlertTriangle,
  CheckCircle,
  Clock,
  Activity,
  Star,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
const stats = [
  {
    id: 1,
    label: "Active Stations",
    value: "42",
    trend: "+2 this month",
    icon: <MapPin className="w-5 h-5 text-blue-600" />,
    bgGradient: "bg-gradient-to-br from-blue-50 to-blue-100/80",
    borderColor: "border-blue-200/60",
    iconBg: "bg-blue-100/80",
    valueColor: "text-blue-900",
    trendColor: "text-blue-600",
  },
  {
    id: 2,
    label: "Running Trains",
    value: "24",
    trend: "98% capacity",
    icon: <Train className="w-5 h-5 text-purple-600" />,
    bgGradient: "bg-gradient-to-br from-purple-50 to-purple-100/80",
    borderColor: "border-purple-200/60",
    iconBg: "bg-purple-100/80",
    valueColor: "text-purple-900",
    trendColor: "text-purple-600",
  },
 
  {
    id: 4,
    label: "System Uptime",
    value: "99.7%",
    trend: "Last 30 days",
    icon: <TrendingUp className="w-5 h-5 text-amber-600" />,
    bgGradient: "bg-gradient-to-br from-amber-50 to-amber-100/80",
    borderColor: "border-amber-200/60",
    iconBg: "bg-amber-100/80",
    valueColor: "text-amber-900",
    trendColor: "text-amber-600",
  },
];

///-----------------Section--3
const lines = [
  {
    name: "Blue Line",
    status: "operational",
    stations: 14,
    uptime: "99.8%",
    dotColor: "bg-blue-500",
  },
  {
    name: "Green Line",
    status: "maintenance",
    stations: 11,
    uptime: "92.3%",
    dotColor: "bg-amber-500",
  },
  {
    name: "Red Line",
    status: "operational",
    stations: 9,
    uptime: "98.5%",
    dotColor: "bg-red-500",
  },
];
const actions = [
  {
    title: "Add Station",
    subtitle: "Create new metro station",
    icon: Plus,
    bgColor: "bg-blue-500",
    textColor: "text-white",
  },
  {
    title: "Import Data",
    subtitle: "Upload CSV/Excel files",
    icon: Upload,
    bgColor: "bg-gray-200",
    textColor: "text-gray-800",
  },
  {
    title: "Export Report",
    subtitle: "Download analytics",
    icon: Download,
    bgColor: "bg-blue-500",
    textColor: "text-white",
  },
  {
    title: "Sync Data",
    subtitle: "Update mobile app",
    icon: RefreshCw,
    bgColor: "bg-green-500",
    textColor: "text-white",
  },
];
//---------Section 4
const performanceMetrics = [
  {
    label: "On-time Performance",
    value: "94.2%",
    icon: Clock,
    trend: "+2.1%",
    trendUp: true,
    color: "text-green-600",
    bgColor: "bg-green-100",
    description: "vs last month",
  },
  {
    label: "Average Delay",
    value: "2.3 min",
    icon: Activity,
    trend: "-0.5 min",
    trendUp: true,
    color: "text-blue-600",
    bgColor: "bg-blue-100",
    description: "improvement",
  },
  {
    label: "Service Frequency",
    value: "Every 4 min",
    icon: Zap,
    trend: "+15%",
    trendUp: true,
    color: "text-purple-600",
    bgColor: "bg-purple-100",
    description: "efficiency",
  },
  {
    label: "Customer Satisfaction",
    value: "4.6/5.0",
    icon: Star,
    trend: "+0.2",
    trendUp: true,
    color: "text-yellow-600",
    bgColor: "bg-yellow-100",
    description: "rating increase",
  },
];

const alerts = [
  {
    id: 1,
    icon: AlertTriangle,
    title: "Station B-04 temporarily closed for maintenance",
    type: "Warning",
    badgeColor: "bg-orange-100 text-orange-700",
    borderColor: "border-orange-200 hover:border-orange-300",
    iconBg: "bg-orange-100",
    iconColor: "text-orange-600",
    time: "2 min ago",
    linkText: "View Details",
    linkColor: "text-blue-600",
    gradient: "bg-gradient-to-r from-orange-50 to-white",
  },
  {
    id: 2,
    icon: CheckCircle,
    title: "All systems operational",
    type: "Success",
    badgeColor: "bg-green-100 text-green-700",
    borderColor: "border-green-200 hover:border-green-300",
    iconBg: "bg-green-100",
    iconColor: "text-green-600",
    time: "15 min ago",
    linkText: "",
    linkColor: "text-green-600",
    gradient: "bg-gradient-to-r from-green-50 to-white",
  },
  {
    id: 3,
    icon: Clock,
    title: "Peak hour schedule activated",
    type: "Info",
    badgeColor: "bg-blue-100 text-blue-700",
    borderColor: "border-blue-200 hover:border-blue-300",
    iconBg: "bg-blue-100",
    iconColor: "text-blue-600",
    time: "1 hour ago",
    linkText: "",
    linkColor: "text-blue-600",
    gradient: "bg-gradient-to-r from-blue-50 to-white",
  },
];

export default function Dashbord() {
  const navigate = useNavigate()
  const [showAddStationModal, setShowAddStationModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isSyncing, setIsSyncing] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);
  const handleActionClick = (idx) => {
    if (idx === 0) {
      navigate("/add-stations");
      setShowAddStationModal(true);
    } else if (idx === 3) {
      setIsSyncing(true);
      setTimeout(() => setIsSyncing(false), 1000);
    } else if (idx === 1) {
      // Import CSV
      if (fileInputRef.current) {
        fileInputRef.current.click(); 
      }
    }
  };
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <MasterLayout>
      {loading && <Loader />}

      <section className="dashboard">
        {/**---------Section-1----------- */}
        <div
          className="relative overflow-hidden rounded-lg p-4 bg-[var(--white)] md:p-6 "
          style={{
            boxShadow:
              "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
          }}
        >
          <div class="relative z-10">
            <h1 class="text-[16px] md:text-[25px] font-bold mb-1 md:mb-2 text-[var(--black)]">
              Indore Metro Operations Dashboard
            </h1>
            <p class="text-[13px] md:text-[15px] text-[var(--grey-text)] mb-3">
              Real-time monitoring and management of metro operations
            </p>
            <div className="flex flex-wrap  gap-3 mt-4">
              <span className="w-full md:w-fit inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800 border border-blue-200">
                System Status: Operational
              </span>
              <span className="w-full md:w-fit inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-green-100 text-green-800 border border-green-200">
                Active Lines: 3
              </span>
            </div>
          </div>
        </div>
        {/**---------Section-2----------- */}
        <section className="mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {stats.map((stat, index) => (
              <div
                key={index}
                className={`group relative overflow-hidden rounded-lg 
      ${stat.bgGradient} ${stat.borderColor}
      border backdrop-blur-sm
      hover:shadow-xl hover:shadow-black/5
      hover:-translate-y-1
      transition-all duration-500 ease-out
      hover:border-opacity-100
      cursor-pointer
    `}
                style={{
                  animationDelay: `${index * 100}ms`,
                }}
              >
                {/* Card Header */}
                <div className="p-4 md:p-6 pb-3">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-[14px] font-normal text-[var(--grey-text)] tracking-wide uppercase">
                      {stat.label}
                    </h3>
                    <div
                      className={`${stat.iconBg} p-2.5 rounded-xl shadow-sm group-hover:scale-110 transition-transform duration-300`}
                    >
                      {stat.icon}
                    </div>
                  </div>

                  {/* Value and Trend */}
                  <div className="flex items-center justify-between">
                    <div
                      className={`text-3xl font-bold ${stat.valueColor} group-hover:scale-105 transition-transform duration-300 origin-left`}
                    >
                      {stat.value}
                    </div>
                    <span
                      className={`text-sm font-medium ${stat.trendColor} bg-white/60 px-2.5 py-1 rounded-full border border-white/40`}
                    >
                      {stat.trend}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
        {/**---------Section-3----------- */}
        <section className="mt-4">
          <div className="grid gap-6 lg:grid-cols-5">
            {/* Metro Lines Status */}
            <div className="col-span-5 lg:col-span-3">
              <div
                className="bg-white rounded-lg p-4 md:p-6"
                style={{
                  boxShadow:
                    "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                }}
              >
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-[18px] font-semibold text-[var(--black)] flex items-center gap-3">
                    <div className="p-2 bg-blue-100 rounded-lg">
                      <Train className="h-6 w-6 text-blue-600" />
                    </div>
                    Metro Lines Status
                  </h3>
                </div>
                <div className="space-y-4">
                  {lines.map((line, idx) => (
                    <div
                      key={idx}
                      className="flex flex-wrap  items-center justify-center gap-2 md:justify-between p-4 bg-white border border-slate-200 rounded-lg hover:shadow transition"
                    >
                      <div className="flex items-center gap-2 md:gap-4">
                        <div className="relative">
                          <div
                            className={`w-3 h-3 rounded-full animate-blink ${line.dotColor}`}
                          />
                        </div>
                        <div>
                          <h4 className="text-[14px] md:text-[16px] font-medium text-[var(--black)]">
                            {line.name}
                          </h4>
                          <p className="text-[12px] md:text-[14px] text-[var(--grey-text)]">
                            {line.stations} stations
                          </p>
                        </div>
                      </div>
                      <div className="text-right">
                        <span
                          className={`inline-flex items-center px-3 py-1 rounded-full text-[12px] font-medium ${
                            line.status === "operational"
                              ? "bg-blue-100 text-blue-800"
                              : "bg-amber-100 text-amber-800"
                          }`}
                        >
                          {line.status}
                        </span>
                        <p className="text-sm text-[var(--grey-text)] mt-1">
                          {line.uptime} uptime
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="col-span-5 lg:col-span-2">
              <div
                className="bg-white h-[100%] rounded-lg p-4 md:p-6"
                style={{
                  boxShadow:
                    "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                }}
              >
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-[18px] font-semibold text-[var(--black)] flex items-center gap-3">
                    <div className="p-2 bg-green-100 rounded-lg">
                      <Zap className="h-6 w-6 text-green-600" />
                    </div>
                    Quick Actions
                  </h3>
                </div>
                <div className="grid lg:grid-cols-2 gap-4">
                  {actions.map((action, idx) => (
                    <button
                      type="button"
                      onClick={() => handleActionClick(idx)}
                      key={idx}
                      className={`${action.bgColor} ${action.textColor} p-4 rounded-lg hover:shadow-lg transition-all duration-200 hover:scale-105 text-left flex flex-col justify-center items-center min-h-[120px]`}
                    >
                      <div className="mb-3">
                        <action.icon
                          className={`w-6 h-6 ${
                            idx === 3 && isSyncing ? "animate-spinOnce" : ""
                          }`}
                        />
                      </div>
                      <div className="text-center">
                        <h3 className="font-bold text-[15px] mb-1">
                          {action.title}
                        </h3>
                        <p
                          className={`text-[14px] ${
                            action.textColor === "text-white"
                              ? "text-white/80"
                              : "text-gray-600"
                          }`}
                        >
                          {action.subtitle}
                        </p>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/**---------Section-4----------- */}
        <section className="mt-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Recent Alerts */}
            <div
              className="bg-white h-[100%] rounded-lg p-4 md:p-6"
              style={{
                boxShadow:
                  "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
              }}
            >
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-[18px] font-semibold text-[var(--black)] flex items-center gap-3">
                  <div className="p-2 bg-orange-100 rounded-lg">
                    <AlertTriangle className="h-6 w-6 text-orange-600" />
                  </div>
                  Recent Alerts
                </h3>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                  Live Updates
                </div>
              </div>
              <div className="space-y-3">
                {alerts.map((alert) => {
                  const Icon = alert.icon;
                  return (
                    <div
                      key={alert.id}
                      className={`group p-4 rounded-lg border ${alert.borderColor} hover:shadow-md transition-all duration-300 ${alert.gradient}`}
                    >
                      <div className="flex items-start gap-3">
                        <div
                          className={`hidden md:block p-2 ${alert.iconBg} rounded-lg mt-1`}
                        >
                          <Icon className={`h-4 w-4 ${alert.iconColor}`} />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center justify-between">
                            <p className="text-[14px] font-medium text-[var(--black)]">
                              {alert.title}
                            </p>
                            <span
                              className={`hidden md:block px-2 py-1 ${alert.badgeColor} text-xs font-medium rounded-full`}
                            >
                              {alert.type}
                            </span>
                          </div>
                          <div className="flex items-center gap-2 mt-2">
                            <Clock className="h-3 w-3 text-gray-400" />
                            <p className="text-[12px] text-[var(--grey-text)] mb-0">
                              {alert.time}
                            </p>
                            {alert.linkText && (
                              <>
                                <span className="text-gray-300">•</span>
                                <p
                                  className={`text-[12px] ${alert.linkColor} hover:underline cursor-pointer mb-0`}
                                >
                                  {alert.linkText}
                                </p>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className="pt-3 border-t border-gray-100">
                  <button className="w-full text-center py-2 text-sm text-blue-600 hover:text-blue-700 rounded-lg transition-colors duration-200 font-medium">
                    View All Alerts →
                  </button>
                </div>
              </div>
            </div>

            {/* Performance Overview */}
            <div
              className="bg-white h-[100%] rounded-lg p-4 md:p-6"
              style={{
                boxShadow:
                  "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
              }}
            >
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-[18px] font-semibold text-[var(--black)] mb-4 flex items-center gap-3">
                  <div className="p-2 bg-blue-100 rounded-lg">
                    <TrendingUp className="h-6 w-6 text-blue-600" />
                  </div>
                  Performance Overview
                </h3>
              </div>

              <div className="grid grid-cols-1 gap-2">
                {performanceMetrics.map((metric, index) => {
                  const IconComponent = metric.icon;
                  return (
                    <div
                      key={index}
                      className="group p-4 rounded-lg border border-gray-200 hover:border-gray-300 hover:shadow-md transition-all duration-300 bg-gradient-to-r from-white to-gray-50"
                    >
                      <div className="flex flex-wrap gap-2 items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div
                            className={`hidden md:block p-2 rounded-lg ${metric.bgColor}`}
                          >
                            <IconComponent
                              className={` h-5 w-5 ${metric.color}`}
                            />
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-600">
                              {metric.label}
                            </p>
                            <p className="text-xs text-gray-400">
                              {metric.description}
                            </p>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="text-lg font-bold text-gray-800">
                            {metric.value}
                          </p>
                          <div
                            className={`flex items-center justify-end gap-1 text-xs font-medium ${
                              metric.trendUp ? "text-green-600" : "text-red-600"
                            }`}
                          >
                            <TrendingUp
                              className={`h-3 w-3 ${
                                metric.trendUp ? "" : "rotate-180"
                              }`}
                            />
                            {metric.trend}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      </section>


      {/**----------CSV UPLoad */}
      <input
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            setUploadedFile(file);
            console.log("📁 Uploaded file:", file.name);
          }
        }}
      />
     
    </MasterLayout>
  );
}
